import { SVGProps } from 'react';
export const SensorIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 52 52' fill='none' {...props}>
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2.5}
      d='M39.79 8.667c7.614 7.615 7.614 19.962 0 27.577M12.211 36.244c-7.615-7.615-7.615-19.962 0-27.577M33.583 14.872a10.724 10.724 0 0 1 0 15.167M18.416 30.039a10.724 10.724 0 0 1 0-15.167'
    />
    <circle
      cx={26.489}
      cy={22.491}
      r={3.499}
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2.5}
    />
    <path stroke='currentColor' strokeLinecap='round' strokeLinejoin='round' strokeWidth={2.5} d='M26 25.705v17.628' />
  </svg>
);
